import { useLayoutEffect } from 'react';
import { useFormikContext } from 'formik';

import { scrollFieldIntoViewOnMobile } from '@/utils/scrollFieldIntoView';
import { queryFirstVisibleFieldInActiveLayout } from '@/utils/dashboardLayoutScope';

/**
 * Setelah submit gagal validasi di viewport mobile (< lg), scroll ke field error pertama
 * sesuai urutan `mobileFieldOrder`, di dalam shell layout yang sedang tampil.
 */
export function useScrollToFirstFormikErrorMobile(mobileFieldOrder: readonly string[]): void {
  const { submitCount, errors } = useFormikContext();

  useLayoutEffect(() => {
    if (submitCount === 0 || typeof window === 'undefined') {
      return;
    }

    if (window.matchMedia('(min-width: 1024px)').matches) {
      return;
    }

    const firstErrorField = mobileFieldOrder.find((field) =>
      Boolean((errors as Record<string, unknown>)[field])
    );
    if (!firstErrorField) {
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const targetElement = queryFirstVisibleFieldInActiveLayout(firstErrorField);
        if (!targetElement) {
          return;
        }
        scrollFieldIntoViewOnMobile(targetElement);
      });
    });
  }, [submitCount, errors, mobileFieldOrder]);
}
